<template>
  <b-card>
    <b-card-title> Create Zoho Reports </b-card-title>
    <validation-observer
      ref="infoRules"
      v-slot="{ invalid }"
      tag="form"
    >
      <b-row>
        <b-col
          cols="12"
          md="6"
        >
          <validation-provider
            #default="validationContext"
            name="Office"
            rules="required"
          >
            <b-form-group
              label="Office"
              label-for="Office"
            >
              <b-form-select
                v-model="zohoReports.office_id"
                :options="optionsOffice"
                :state="getValidationState(validationContext)"
                trim
                placeholder="Add Office Name"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider></b-col>
        <b-col
          cols="12"
          md="6"
        >
          <validation-provider
            #default="validationContext"
            name="type"
            rules="required"
          >
            <b-form-group
              label="type"
              label-for="type"
            >
              <b-form-select
                v-model="zohoReports.type"
                :options="optionsType"
                :state="getValidationState(validationContext)"
                trim
                placeholder="type of invoice"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider></b-col>

        <b-col
          cols="12"
          md="6"
        >
          <validation-provider
            #default="validationContext"
            name="from"
            rules="required"
          >
            <b-form-group
              label="Name Training"
              label-for="From"
            >
              <b-form-datepicker
                v-model="zohoReports.from_date"
                type="text"
                :state="getValidationState(validationContext)"
                trim
                placeholder="From"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider></b-col>
        <b-col
          cols="12"
          md="6"
        >
          <validation-provider
            #default="validationContext"
            name="To"
            rules="required"
          >
            <b-form-group
              label="To"
              label-for="To"
            >
              <b-form-datepicker
                v-model="zohoReports.to_date"
                type="text"
                :state="getValidationState(validationContext)"
                trim
                placeholder="To"
              />
              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider></b-col>
      </b-row>

      <b-row>
        <b-col
          cols="12"
          class="d-flex justify-content-end"
        >
          <b-button
            v-if="!loader"
            variant="outline-success"
            class="mr-4"
            :disabled="invalid || Object.values(errors).length > 0"
            @click="addZohoReports()"
          >
            <img
              src="@/assets/images/icons/excel.png"
              width="30"
              height="50"
            >
          </b-button>
          <b-button
            v-if="loader"
            variant="outline-success"
            disabled
            class="p-2 mr-4"
          >
            <b-spinner
              width="50"
              height="60"
              label="Spinning"
            />
          </b-button>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import formValidation from '@core/comp-functions/forms/form-validation'
import { required } from '@validations'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
import { ref } from '@vue/composition-api'
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {},
  data() {
    return {
      required,
      loader: false,
      validationErrors: {},
      errors: {},
      optionsType: ['invoices', 'expenses', 'payments', 'all-reports'],
    }
  },
  computed: {
    optionsOffice() {
      return this.$store.getters['generalData/offices/offices'].filter(
        office => office.text !== 'All Offices' && office.value !== null,
      )
    },
  },

  async mounted() {
    if (!this.$store.getters['generalData/offices/officesLoaded']) {
      this.localDataLoad = true
      await this.$store.dispatch('generalData/offices/fetchOffices')
      this.localDataLoad = false
    }
  },
  setup() {
    const { getValidationState } = formValidation()
    const zohoReports = ref({})
    return {
      getValidationState,
      zohoReports,
    }
  },
  methods: {

    async addZohoReports() {
      try {
        this.loader = true
        const response = await axios.post(`zoho-reports/${this.zohoReports.type}`, this.zohoReports, {
          responseType: 'blob',
        })

        if (response.status === 200) {
          const now = new Date()
          const formattedDate = now.toISOString().split('T')[0]
          const formattedTime = now.toTimeString().split(' ')[0].replace(/:/g, '-')
          const dateTimeString = `${formattedDate}_${formattedTime}`

          const blob = new Blob([response.data], { type: response.data.type })
          const url = window.URL.createObjectURL(blob)

          const link = document.createElement('a')
          link.href = url
          link.download = dateTimeString
          link.click()

          this.$toasted.show('Updated Successfully', {
            position: 'top-center',
            duration: 3000,
          })
        }
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `${error}`,
            icon: 'BellIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.loader = false
      }
    },

  },
}
</script>
